






























import { Component, Mixins } from "vue-property-decorator";
import Shared from "../common/shared";
import BaseServiceMixin from "../mixins/base.service.mixin";

@Component({})
export default class AcceptInvite extends Mixins(BaseServiceMixin) {
  private async mounted() {
    Shared.setSignUp(true);
    await this.$oidc.initialiseManager(this.vuexStore.environment);

    const params = this.$route.query;
    if (params.id) {
      localStorage.removeItem(Shared.localStorageKeys.INVITATION_ID);
      localStorage.setItem(Shared.localStorageKeys.INVITATION_ID, params.id.toString());
      this.$oidc.signIn();
    } else {
      Shared.showToastMessage(Shared.messages.INVALID_INVITATION, "is-danger");
    }
  }
}
